import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import { getStep } from "containers/CreateWizard/reducer";

import CostsWaterfall from "components/Costs/CostsWaterfall";
import MiniCostsWaterfall from "components/Costs/MiniCostsWaterfall";

class CostsWaterfallContainer extends React.PureComponent {
  render() {
    const { isMini, step, index } = this.props;

    return isMini ? (
      <MiniCostsWaterfall {...this.props} isShow={true} />
    ) : (
      <CostsWaterfall {...this.props} isShow={true} />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateConversionGain: (conversionGain) => dispatch(setupReducer.updateConversionGain(ownProps.id, conversionGain)),
  updateConversionCost: (conversionCost) => dispatch(setupReducer.updateConversionCost(ownProps.id, conversionCost)),
  updateConversionMissed: (conversionMissed) =>
    dispatch(setupReducer.updateConversionMissed(ownProps.id, conversionMissed)),
  updateConversionSaved: (conversionSaved) =>
    dispatch(setupReducer.updateConversionSaved(ownProps.id, conversionSaved)),
  updateTruePositive: (truePositive) => dispatch(setupReducer.updateTruePositive(ownProps.id, truePositive)),
  updateFalsePositive: (falsePositive) => dispatch(setupReducer.updateFalsePositive(ownProps.id, falsePositive)),
  updateTrueNegative: (trueNegative) => dispatch(setupReducer.updateTrueNegative(ownProps.id, trueNegative)),
  updateFalseNegative: (falseNegative) => dispatch(setupReducer.updateFalseNegative(ownProps.id, falseNegative)),

  updateFalseNegativeLabel: (falseNegativeLabel) =>
    dispatch(setupReducer.updateFalseNegativeLabel(ownProps.id, falseNegativeLabel)),
  updateFalsePositiveLabel: (falsePositiveLabel) =>
    dispatch(setupReducer.updateFalsePositiveLabel(ownProps.id, falsePositiveLabel)),
  updateTrueNegativeLabel: (trueNegativeLabel) =>
    dispatch(setupReducer.updateTrueNegativeLabel(ownProps.id, trueNegativeLabel)),
  updateTruePositiveLabel: (truePositiveLabel) =>
    dispatch(setupReducer.updateTruePositiveLabel(ownProps.id, truePositiveLabel)),
  updateNetImpactLabel: (netImpactLabel) => dispatch(setupReducer.updateNetImpactLabel(ownProps.id, netImpactLabel)),
  updateHideCosts: (hideCosts) => dispatch(setupReducer.updateHideCosts(ownProps.id, hideCosts))
});

const mapStateToProps = (state, ownProps) => ({
  conversionGain: setupReducer.getConversionGain(state, ownProps.id),
  conversionCost: setupReducer.getConversionCost(state, ownProps.id),
  conversionMissed: setupReducer.getConversionMissed(state, ownProps.id),
  conversionSaved: setupReducer.getConversionSaved(state, ownProps.id),
  truePositive: setupReducer.getTruePositive(state, ownProps.id),
  falsePositive: setupReducer.getFalsePositive(state, ownProps.id),
  trueNegative: setupReducer.getTrueNegative(state, ownProps.id),
  falseNegative: setupReducer.getFalseNegative(state, ownProps.id),

  truePositiveLabel: setupReducer.getTruePositiveLabel(state, ownProps.id),
  falsePositiveLabel: setupReducer.getFalsePositiveLabel(state, ownProps.id),
  trueNegativeLabel: setupReducer.getTrueNegativeLabel(state, ownProps.id),
  falseNegativeLabel: setupReducer.getFalseNegativeLabel(state, ownProps.id),

  netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),

  currentROI: setupReducer.getCurrentROI(state, ownProps.id),

  outcome: setupReducer.getOutcomeFromDataset(state, ownProps.id),
  success: setupReducer.getSuccessValue(state, ownProps.id),
  sucessOptions: setupReducer.getSuccessOptions(state, ownProps.id),

  timePeriod: setupReducer.getTimePeriod(state, ownProps.id),

  defaultTruePositive: setupReducer.getDefaultTruePositive(state, ownProps.id),
  defaultFalsePositive: setupReducer.getDefaultFalsePositive(state, ownProps.id),

  isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",

  step: getStep(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(CostsWaterfallContainer);
